<template>

  <v-card
    max-width="640"
    >
    <v-img
      :src="artistInfo.artistImage"
    ></v-img>
    <v-card-title>
      {{artistInfo.name}}
    </v-card-title>

    <v-card-subtitle class="text-left">
      {{ artistInfo.enName }}
    </v-card-subtitle>

    <v-card-text>
      {{artistInfo.artistInfo}}
    </v-card-text>

    <v-card-subtitle class="text-left text-center">
      主な活動拠点<br/>
      {{artistInfo.activityBase}}
    </v-card-subtitle>

    <!-- <iframe v-if="youtubeSrc" width="560" height="315" :src="artistInfo.youtubeSrc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->

    <v-card-text>
      <div v-if="artistInfo.official.name">
        公式ホームページ<br/>
        <a :href="artistInfo.official.url" class="text-decoration-none" target="_blank">{{artistInfo.official.name}}</a>
        <br/>
        <br/>
      </div>
      <div v-else-if="artistInfo.official.url">
        <a :href="artistInfo.official.url" class="text-decoration-none" target="_blank">公式ホームページ</a>
        <br/>
        <br/>
      </div>

      <div v-if="artistInfo.musicSns.spotify || artistInfo.musicSns.youtube || artistInfo.musicSns.apple">
        もっと音楽を聴く<br/>

        <div
          v-for="url,index in artistInfo.musicSns"
          :key="index"
          >
          <a
            v-if="url"
            class="text-decoration-none"
            :href="url" target="_blank">
            <span>
              <v-icon :color="index">
              fab fa-{{index}}
              </v-icon>
              {{index !== 'apple' ? index : 'Apple Music'}}
            </span>
          </a>
        </div>
        <br/>

      </div>

      <div v-if="artistInfo.sns.twitter || artistInfo.sns.facebook || artistInfo.sns.instagram">
      SNSをフォローする<br/>

        <div
          v-for="url,index in artistInfo.sns"
          :key="index"
          >
          <a
            v-if="url"
            class="text-decoration-none"
            :href="url" target="_blank">
            <span>
              <v-icon :color="index">
              fab fa-{{index}}
              </v-icon>
              {{index}}
            </span>
          </a>
        </div>
        <br/>
      </div>

      <!-- CDを購入する<br/> -->
      <div
      v-if="!artistInfo.email"
      >
        <a
          :href="artistInfo.purchaseLink"
          :id="setGoogleTagId(artistInfo.name)"
          class="text-decoration-none buy-albumn"
          target="_blank">
          <v-btn
            >
            CDを購入する
          </v-btn>
        </a>
      </div>
      <div
      v-else
      >
        <a
          :href="getEmailLink(artistInfo.email)"
          :id="setGoogleTagId(artistInfo.name)"
          class="text-decoration-none buy-albumn"
          >
        <v-btn
          >
          CDを購入する
        </v-btn>
        </a>
        <br/>
        ＊ rintauros@gmail.com までご連絡ください
      </div>

    </v-card-text>

  </v-card>

</template>

<script>
  export default {
    name: 'ArtistInfo',
    props: ['artistInfo'],
    methods: {
      getEmailLink (email) {
        return 'mailto:' + email + '?subject=音楽で旅に出よう！で「Limerick Junction」を聴きました&amp;'
      },
      setGoogleTagId(artistName) {
        return 'gt-cd-' + artistName
      }
    },
  }
  //
</script>
